const ROUTE_PATHS = {
  HOME: "/",
  TRIP_REQUEST_PAGE: "/trip-request-listing",
  TRIP_DETAILS: (tripId = ":tripId") => `/trip-details/${tripId}`,
  ESCORT_DETAILS: (tripId = ":tripId") => `/special-onboarding-details/${tripId}`,
  AFTER_HOURS_DETAILS: (tripId = ":tripId") => `/after-hours-details/${tripId}`,
  HISTORIC_TRIPS_PAGE: "/historic-trips",
  HISTORIC_TRIP_DETAILS: (tripId = ":tripId") => `/historic-trip-details/${tripId}`,
  UNREGISTERED_AIRCRAFT_TRIPS_PAGE: "/unregistered-aircraft-trips",
  UNREGISTERED_AIRCRAFT_TRIPS_DETAILS: "/unregistered-aircraft-trips/details",
  UNREGISTERED_AIRCRAFT_TRIP_DETAILS: "/unregistered-aircraft-trips/details/trip",
  NOTIFICATIONS_PAGE: "/notifications",


};

export default ROUTE_PATHS;
